import { isPrerender } from "@faire/web/common/user-agent/isPrerender";
import { MinWidthBreakpoints } from "@faire/web/common/Viewport";
import { ResponsiveValues } from "@faire/web/slate/Theme/ResponsiveValues";
import { Location } from "history";

// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { BrandUrlParameters } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/useBrandUrl";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { ProductUrlParameters } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductLink/useProductLinkProps";
import { ProductLinkProps } from "@faire/retailer/features/MarketplaceItems/ProductTile";
import { generateProductLinkPropsForLoggedOutRetailer } from "@faire/retailer/lib/generateProductLinkPropsForLoggedOutRetailer";
import { isAdmin } from "@faire/retailer/lib/isAdmin";
import { isLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";
import { brandPage } from "@faire/retailer/paths";
import { ProductPagePaths } from "@faire/retailer/paths/ProductPage";

export const handleGenerateProductLinkProps =
  (
    queryString: string,
    params: ProductUrlParameters,
    filterKeys: string[],
    location: Location
  ) =>
  (): ProductLinkProps | undefined => {
    const { token, brandToken, impressionId, selectedProductOptionToken } =
      params;
    if (!token) {
      return { productUrl: "" };
    }

    const productPageLink = ProductPagePaths.index(token, {
      refS: queryString,
      refF: filterKeys,
      productOptionToken: selectedProductOptionToken,
      impressionId: impressionId,
    });

    if (isLoggedInRetailer() || isAdmin() || isPrerender()) {
      return { productUrl: productPageLink };
    }

    // logged out users should not see ref parameters (SEO requirement)
    return generateProductLinkPropsForLoggedOutRetailer({
      productToken: token,
      brandToken: brandToken,
      location,
    });
  };

export const handleGenerateBrandUrl =
  (queryString: string, params: BrandUrlParameters) => () => {
    // logged out users should not see ref parameters (SEO requirement)
    const refS = isLoggedInRetailer() ? queryString : undefined;
    const refP =
      isLoggedInRetailer() && params.productToken
        ? [params.productToken]
        : undefined;
    return params.brandToken
      ? brandPage(params.brandToken, {
          refS,
          refP,
          impressionId: params.impressionId,
        })
      : "";
  };

export const useGetItemsPerRowResponsive = (
  isSideBarVisible?: boolean
): ResponsiveValues<number> => {
  return isSideBarVisible
    ? ITEMS_PER_ROW_RESPONSIVE_SIDEBAR_XL_DESKTOP
    : ITEMS_PER_ROW_RESPONSIVE_XL_DESKTOP;
};

export const ITEMS_PER_ROW_RESPONSIVE: ResponsiveValues<number> = {
  mobileAndAbove: 2,
  tabletAndAbove: 4,
  desktopAndAbove: 5,
  xLargeAndAbove: 5,
  xxLargeDesktop: 5,
};

const ITEMS_PER_ROW_RESPONSIVE_SIDEBAR: ResponsiveValues<number> = {
  mobileAndAbove: 2,
  tabletAndAbove: 3,
  desktopAndAbove: 4,
  xLargeAndAbove: 4,
  xxLargeDesktop: 4,
};

const ITEMS_PER_ROW_RESPONSIVE_XL_DESKTOP: ResponsiveValues<number> = {
  ...ITEMS_PER_ROW_RESPONSIVE,
  desktopAndAbove: 5,
  xLargeAndAbove: 6,
  xxLargeDesktop: 6,
};

const ITEMS_PER_ROW_RESPONSIVE_SIDEBAR_XL_DESKTOP: ResponsiveValues<number> = {
  ...ITEMS_PER_ROW_RESPONSIVE_SIDEBAR,
  desktopAndAbove: 4,
  xLargeAndAbove: 5,
  xxLargeDesktop: 5,
};

export const SEARCH_PAGE_XL_BREAKPOINTS: MinWidthBreakpoints = {
  tablet: 768,
  desktop: 1024,
  xlarge: 1440,
  xxlarge: 1920,
};
